<template>
  <v-menu
    ref="datePickerDialog"
    v-model="isVisible"
    :close-on-content-click="false"
    :return-value.sync="selected"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        class="pt-0 mt-0"
        v-model="selected"
        placeholder="Select Visit Date"
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      no-title
      :min="minDate"
      :pickerDate.sync="pickerDate"
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="isVisible = false"> Cancel </v-btn>
      <v-btn
        text
        color="primary"
        @click="$refs.datePickerDialog.save(selected)"
      >
        OK
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>
<script>
import moment from 'moment'
export default {
  name: 'AMSDatePicker',
  props: {
    value: {
      type: String,
      default: null
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data: function () {
    return {
      isVisible: false,
      date: this.value
        ? moment(this.value, 'DD-MM-YYYY').format('YYYY-MM-DD')
        : null,
      selected: this.value ? this.value : null,
      minDate: new Date().toISOString().split('T')[0],
      pickerDate: null
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      this.selected = newVal || null
      this.date = newVal
        ? moment(newVal, 'DD-MM-YYYY').format('YYYY-MM-DD')
        : null
    },
    date: function (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.selected = moment(newVal, 'YYYY-MM-DD').format('DD-MM-YYYY')
        this.$emit('input', { date: this.selected, index: this.index })
      }
    },
    isVisible: function (newVal) {
      if (newVal && this.value === null) {
        const today = new Date().toISOString().split('T')[0]
        this.pickerDate = today
      }
    }
  }
}
</script>
